// builds the collection routes from the product data
function BuildCollectieRoute(productsData) {
  let collectieList = {};

  for (let key in productsData) {
    collectieList[key] = {};

    if (typeof productsData[key] === "object") {
      //create path lists from data
      for (const collectieKey in productsData[key]) {
        // if product data has more than 1 assortiment ( product data consists out of several files )
        if (
          Object.keys(productsData[key]).length > 1 &&
          typeof productsData[key][collectieKey] === "object"
        ) {
          // create and modify data for collectieslist
          const splitColKey = collectieKey.split("-");

          let collectiePath = "";

          if (splitColKey.length !== 0) {
            for (let i = 0; i < splitColKey.length; i++) {
              if (splitColKey[i] === "pvc") {
                splitColKey[i] =
                  (
                    splitColKey[i][0] +
                    splitColKey[i][1] +
                    splitColKey[i][2]
                  ).toUpperCase() + splitColKey[i].slice(3);
              } else if (splitColKey[i] === "xl") {
                splitColKey[i] = (
                  splitColKey[i][0] + splitColKey[i][1]
                ).toUpperCase();
              } else {
                splitColKey[i] =
                  splitColKey[i][0].toUpperCase() + splitColKey[i].slice(1);
              }
              if (i === 0) {
                collectiePath += splitColKey[i];
              } else {
                collectiePath += " " + splitColKey[i];
              }
            }
          } else {
            collectiePath =
              collectieKey[0].toUpperCase() + collectieKey.slice(1);
          }

          collectieList[key][collectieKey] = {
            path: collectiePath,
            name: productsData[key][collectieKey][0].productCode.slice(0, 6),
          };
        }
        // end collectie loop
      }
      // end assortiment loop
    }
  }
  return collectieList;
  // end buildCollectionRoute
}

function buildAssortimentRouting(selectedLang) {
  const assortiments = getData("assortiment", selectedLang);

  let routes = {};

  for (let indexAss in assortiments) {
    let assortment = assortiments[indexAss].code;

    routes[assortment] = {
      path: assortiments[indexAss].label.replaceAll(" ", "-").toLowerCase(),
      name: assortment,
    };
  }

  return routes;

  // end buildAssortimentRouting
}

function buildCollectionRouting(selectedLang) {
  const assortiments = getData("assortiment", selectedLang);

  let routes = {};

  for (let indexAss in assortiments) {
    const collections = getData(
      `${assortiments[indexAss].code.toLowerCase()}/collections`,
      selectedLang
    );
    let assortment = assortiments[indexAss].code;

    routes[assortment] = {};

    for (let indexCol in collections) {
      routes[assortment][collections[indexCol].code] = {
        path: collections[indexCol].label.replaceAll(" ", "-").toLowerCase(),
        name: assortiments[indexAss].code + collections[indexCol].code,
      };
    }
  }

  return routes;
}

function BuildProductRoute(productsData) {
  let productList = {};

  for (let key in productsData) {
    productList[key.toUpperCase()] = {};

    //create path lists from data
    for (const collectieKey in productsData[key]) {
      if (
        collectieKey !== "collections" &&
        typeof productsData[key][collectieKey] === "object"
      ) {
        // create product list
        for (let productKey in productsData[key][collectieKey]) {
          const product = productsData[key][collectieKey][productKey];

          let productCode = "";

          if (product.code !== "" && product.code !== undefined) {
            productCode = product.code + " - ";
          }

          let productColor = "";

          if (product.kleur !== "" && product.kleur !== undefined) {
            if (product.kleur !== product.naam) {
              productColor = " - " + product.kleur;
            }
          }

          const productPath = `${productCode.replaceAll(" ", "")}${product.naam
            .replaceAll(" ", "-")
            .replaceAll("/", "-")}${productColor.replaceAll(" ", "")}`;

          if (
            !Object.prototype.hasOwnProperty.call(
              productList[key.toUpperCase()],
              product.productCode
            )
          ) {
            productList[key.toUpperCase()][product.productCode] = {
              path: productPath.replaceAll("-+-", "-"),
              name: product.productCode,
            };
          }
          // end product loop
        }
      }
      // end collection loop
    }
    // end assortiment loop
  }
  return productList;
  // end buildCollectionRoute
}

// get json data
function getData(file = undefined, selectedLang = "en-EN") {
  let lang = getLangCode(selectedLang);

  if (typeof file == "string") {
    try {
      const response = require(`@/assets/products/json/${lang}/${file}.json`);
      return response;
    } catch (e) {
      return `error: function getData cant find module @/assets/products/json/${lang}/${file}.json.`;
    }
  } else {
    return `error: function getData input parameter: file is not of type string.`;
  }
}

// this function gets and builds the product data object
function buildProductData(selectedLang) {
  let data = {};

  // get and build assortiment data
  const assortiments = getData("assortiment", selectedLang);

  if (typeof assortiments !== "object") {
    data = assortiments;
  } else {
    // get and build collection data
    for (const indexAssortiment in assortiments) {
      const assortiment = assortiments[indexAssortiment];
      const collectionPath = `${assortiment.code.toLowerCase()}`;
      const collections = getData(
        `${collectionPath}/collections`,
        selectedLang
      );

      let collectionBuild = {};

      // get and build product data
      for (const indexCollection in collections) {
        const collection = collections[indexCollection];
        const pathProduct = `${collectionPath}/${collection.code
          .replaceAll(" ", "-")
          .toLowerCase()}`;
        const products = getData(pathProduct, selectedLang);

        collectionBuild[collection.code.toLowerCase()] = products;

        // end collections loop
      }

      data[assortiment.code.replaceAll(" ", "").toLowerCase()] =
        collectionBuild;

      // end assortiment loop
    }

    return data;
  }
}

// gets assortment properties
function getAssortmentProp(
  selectedAssortmentCode = "",
  selectedLang = "en-EN"
) {
  // get assortiment data
  const assortiments = getData("assortiment", selectedLang);

  if (selectedAssortmentCode !== "") {
    for (const index in assortiments) {
      if (assortiments[index].code === selectedAssortmentCode) {
        return {
          code: assortiments[index].code,
          label: assortiments[index].label,
        };
      }
    }
  }
  // end getAssortmentProp
}

function getCollectionList(
  selectedAssortmentCode = "",
  selectedLang = "en-EN"
) {
  // check inputs
  if (selectedAssortmentCode == "" || selectedAssortmentCode.length !== 3) {
    return "Error: function getCollectionList input parameter: selected assortment is not a valid assortment code";
  }

  if (
    selectedLang == "" ||
    selectedLang.length < 2 ||
    selectedLang.length > 5
  ) {
    return "Error: function getCollectionList input parameter: selected language is not a valid language code";
  }

  let lang = getLangCode(selectedLang);

  return getData(`${selectedAssortmentCode.toLowerCase()}/collections`, lang);
}

function getCollectionProp(
  selectedAssortmentCode = "",
  selectedCollectionCode = "",
  selectedLang = "en-EN"
) {
  const collections = getData(
    `${selectedAssortmentCode.toLowerCase()}/collections`,
    selectedLang
  );

  if (selectedAssortmentCode !== "") {
    for (const index in collections) {
      if (collections[index].code === selectedCollectionCode) {
        return {
          code: collections[index].code,
          label: collections[index].label,
        };
      }
    }
  }
}

// returns all the product data from a collection
function getCollectionData(
  selectedAssortment = "",
  selectedCollection = "",
  selectedLang = ""
) {
  // check inputs
  if (selectedAssortment == "" || selectedAssortment.length !== 3) {
    return "Error: function getCollectionData input parameter: selected assortment is not a valid assortment code";
  }

  if (selectedCollection == "" || selectedCollection.length !== 3) {
    return "Error: function getCollectionData input parameter: selected collection is not a valid collection code";
  }

  if (
    selectedLang == "" ||
    selectedLang.length < 2 ||
    selectedLang.length > 5
  ) {
    return "Error: function getCollectionData input parameter: selected language is not a valid language code";
  }

  let lang = getLangCode(selectedLang);

  // get collection label
  const collectionProp = getCollectionProp(
    selectedAssortment,
    selectedCollection,
    selectedLang
  );

  // get collection data
  try {
    const response = require(`@/assets/products/json/${lang}/${selectedAssortment.toLowerCase()}/${collectionProp.code
      .replaceAll(" ", "-")
      .toLowerCase()}.json`);
    return response;
  } catch (e) {
    return `Error: function getCollectionData cant find module @/assets/products/json/${lang}/${selectedAssortment.toLowerCase()}/${collectionProp.code
      .replaceAll(" ", "-")
      .toLowerCase()}.json.`;
  }
  // end getCollectionData
}

// gets the product data by selected product code
function getProductData(selectedProductCode, selectedLang) {
  // check inputs
  if (selectedProductCode == "" || selectedProductCode.length !== 11) {
    return "Error: function getCollectionData input parameter: selected product code is not a valid product code";
  }

  if (
    selectedLang == "" ||
    selectedLang.length < 2 ||
    selectedLang.length > 5
  ) {
    return "Error: function getCollectionData input parameter: selected language is not a valid language code";
  }

  let lang = getLangCode(selectedLang);

  // get codes
  const assortmentCode = selectedProductCode.slice(0, 3);
  const collectionCode = selectedProductCode.slice(3, 6);

  // get collection label
  const collectionProp = getCollectionProp(
    assortmentCode,
    collectionCode,
    selectedLang
  );
  const collections = getCollectionData(
    assortmentCode,
    collectionCode,
    selectedLang
  );

  if (typeof collections === "object") {
    for (let index in collections) {
      if (collections[index].productCode === selectedProductCode) {
        return collections[index];
      }
    }
    return `Error: product code ${selectedProductCode} not found in @/assets/products/${lang}/${assortmentCode.toLowerCase()}/${collectionProp.label.toLowerCase()}.json.`;
  } else {
    return collections.replaceAll("getCollectionData", "getProductData");
  }

  // end getProductData
}

// gets the pathing codes from the vue this.$route.name
function getSelection(vueRouterName) {
  let routeName = vueRouterName.split("-");

  return {
    lang: routeName[0],
    code: routeName[1],
    assortmentCode: routeName[1].slice(0, 3),
    collectionCode: routeName[1].slice(3, 6),
    productCode: routeName[1].slice(6),
  };
}

function getLangCode(langCode) {
  let lang = "";

  if (langCode.includes("-")) {
    const langArray = langCode.split("-");
    lang = langArray[0];
  } else {
    lang = langCode;
  }
  return lang;
}

const trompetty = {
  getAssortmentProp,
  getCollectionProp,
  getCollectionData,
  getCollectionList,
  getData,
  getLangCode,
  getProductData,
  getSelection,
  buildAssortimentRouting,
  BuildCollectieRoute,
  buildCollectionRouting,
  BuildProductRoute,
  buildProductData,
};

export default trompetty;
